<template>
  <div style="backgrouns:#ffffff;">
    <div :id="id" :style="{height:height,width:width}"></div>
  </div>
</template>
<script>
import * as echarts from 'echarts'
import { MP } from '../baiduMap.js'
import resize from './mixins/resize'

export default {
  mixins: [resize],
  props: {
    option: {
      type: Object
    },
    name: {
      type: String,
      default: '空'
    },
    id: {
      type: String,
      default: 'chart11111'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '200px'
    }
  },
  data () {
    return {
      chart: null,
      geoCoordMap: {
        北京: [116.407394, 39.904211],
        天津: [117.200983, 39.084158],
        上海: [121.473662, 31.230372],
        重庆: [106.551643, 29.562849],
        河北: [114.530235, 38.037433],
        山西: [112.562678, 37.873499],
        辽宁: [123.431382, 41.836175],
        吉林: [125.32568, 43.897016],
        黑龙江: [126.661665, 45.742366],
        江苏: [118.762765, 32.060875],
        浙江: [120.152585, 30.266597],
        安徽: [117.329949, 31.733806],
        福建: [119.295143, 26.100779],
        江西: [115.81635, 28.63666],
        山东: [117.019915, 36.671156],
        河南: [113.753394, 34.765869],
        湖北: [114.341745, 30.546557],
        湖南: [112.9836, 28.112743],
        广东: [113.26641, 23.132324],
        海南: [110.349228, 20.017377],
        四川: [104.075809, 30.651239],
        贵州: [106.70546, 26.600055],
        云南: [102.710002, 25.045806],
        陕西: [108.954347, 34.265502],
        甘肃: [103.826447, 36.05956],
        青海: [101.780268, 36.620939],
        内蒙古: [111.76629, 40.81739],
        广西: [108.327546, 22.815478],
        西藏: [91.117525, 29.647535],
        宁夏: [106.259126, 38.472641],
        新疆: [87.627704, 43.793026],
        香港: [114.171203, 22.277468],
        澳门: [113.543028, 22.186835],
        台湾: [121.509062, 25.044332],
        广州: [113.280637, 23.125178],
        深圳: [114.085947, 22.547],
        苏州: [120.619585, 31.299379],
        成都: [104.065735, 30.659462],
        武汉: [114.298572, 30.584355],
        杭州: [120.153576, 30.287459],
        南京: [118.767413, 32.041544],
        青岛: [120.369557, 36.094406],
        长沙: [112.982279, 28.19409],
        无锡: [120.301663, 31.574729],
        宁波: [121.549792, 29.868388],
        佛山: [113.122717, 23.028762],
        郑州: [113.665412, 34.757975],
        济南: [117.000923, 36.675807],
        福州: [119.306239, 26.075302],
        南通: [120.864608, 32.016212]
      }
    }
  },
  mounted () {
    if (typeof (BMap) !== 'undefined') {
      this.initChart()
    } else {
      this.$nextTick(function () {
        MP(this.ak).then(BMap => {
          this.initChart()
        })
      })
    }
  },

  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    convertData (data) {
      var res = []
      for (var i = 0; i < data.length; i++) {
        var geoCoord = this.geoCoordMap[data[i].name]
        if (geoCoord) {
          res.push({
            name: data[i].name,
            value: geoCoord.concat(data[i].value)
          })
        }
      }
      return res
    },

    initChart () {
      let a = this.option.data
      const max = a.reduce((num1, num2) => {
        let num11 = parseInt(num1.value)
        let num21 = parseInt(num2.value)
        return num11 > num21 ? num1 : num2
      })
      const min = a.reduce((num1, num2) => {
        let num11 = parseInt(num1.value)
        let num21 = parseInt(num2.value)
        return num11 < num21 ? num1 : num2
      })
      const multiple = this.option.config.multiple ? this.option.config.multiple : 5
      const symbolSize = (parseInt(max.value) / parseInt(min.value)) * multiple
      this.chart = echarts.init(document.getElementById(this.id), {}, { renderer: 'svg' })
      this.chart.setOption({
        tooltip: {
          trigger: 'item'
        },
        bmap: {
          center: [104.803805, 36.499090],
          zoom: this.option.config.zoom ? this.option.config.zoom : 5,
          roam: false,
          mapStyle: {
            styleJson: [{
              'featureType': 'water',
              'elementType': 'all',
              'stylers': {
                'color': '#1f2840'
              }
            }, {
              'featureType': 'land',
              'elementType': 'all',
              'stylers': {
                'color': '#1f232f'
              }
            }, {
              'featureType': 'railway',
              'elementType': 'all',
              'stylers': {
                'visibility': 'off'
              }
            }, {
              'featureType': 'highway',
              'elementType': 'all',
              'stylers': {
                'color': '#3e4867'
              }
            }, {
              'featureType': 'highway',
              'elementType': 'labels',
              'stylers': {
                'visibility': 'off'
              }
            }, {
              'featureType': 'arterial',
              'elementType': 'geometry',
              'stylers': {
                'color': '#fefefe'
              }
            }, {
              'featureType': 'arterial',
              'elementType': 'geometry.fill',
              'stylers': {
                'color': '#fefefe'
              }
            }, {
              'featureType': 'poi',
              'elementType': 'all',
              'stylers': {
                'visibility': 'off'
              }
            }, {
              'featureType': 'green',
              'elementType': 'all',
              'stylers': {
                'visibility': 'off'
              }
            }, {
              'featureType': 'subway',
              'elementType': 'all',
              'stylers': {
                'visibility': 'off'
              }
            }, {
              'featureType': 'manmade',
              'elementType': 'all',
              'stylers': {
                'color': '#d1d1d1'
              }
            }, {
              'featureType': 'local',
              'elementType': 'all',
              'stylers': {
                'color': '#d1d1d1'
              }
            }, {
              'featureType': 'arterial',
              'elementType': 'labels',
              'stylers': {
                'visibility': 'off'
              }
            }, {
              'featureType': 'boundary',
              'elementType': 'all',
              'stylers': {
                'color': '#353f58'
              }
            }, {
              'featureType': 'building',
              'elementType': 'all',
              'stylers': {
                'color': '#d1d1d1'
              }
            }, {
              'featureType': 'label',
              'elementType': 'all',
              'stylers': {
                'visibility': 'off'
              }
            }]
          }
        },
        series: [
          {
            type: 'scatter',
            coordinateSystem: 'bmap',
            data: this.convertData(this.option.data),
            symbolSize: function (val) {
              return val[2] / symbolSize
            },
            showEffectOn: 'render',
            rippleEffect: {
              brushType: 'stroke'
            },
            label: {
              normal: {
                formatter: '{b}',
                position: 'right',
                show: true
              },
              emphasis: {
                show: true
              }
            },
            emphasis: {
              label: {
                show: true
              }
            },
            itemStyle: {
              normal: {
                color: '#33D1FE'
              }
            }
          }
          // {
          //   name: 'Top 5',
          //   type: 'effectScatter',
          //   coordinateSystem: 'bmap',
          //   data: this.convertData(this.option.data.sort(function (a, b) {
          //     return b.value - a.value
          //   }).slice(0, 5)),
          //   symbolSize: function (val) {
          //     return val[2] / symbolSize
          //   },
          //   showEffectOn: 'render',
          //   rippleEffect: {
          //     brushType: 'stroke'
          //   },
          //   label: {
          //     normal: {
          //       formatter: '{b}',
          //       position: 'right',
          //       show: true
          //     }
          //   },
          //   itemStyle: {
          //     normal: {
          //       color: '#FFD71C',
          //       shadowBlur: 2,
          //       shadowColor: '#333'
          //     }
          //   },
          //   zlevel: 1
          // }
        ]
      })
    }
  },
  created () {}
}
</script>
<style lang="stylus">
#chart11111 {
  background: #ffffff;
}
.anchorBL{
  display:none
}
</style>
